import TutorialDocument from "./tutorial-document-frame";

export default TutorialDocument;